import { RenderResultWithSsr } from '../../../lib/renderTypes';
import { div } from '../../../render/html';
import { DANGEROUSLY_HTML_CONTENT } from '../../../render/incremental-hyperscript';

export function renderChatbotButtonLoaded(
  chatbotSafeHtml: string,
): RenderResultWithSsr | undefined {
  return div({ [DANGEROUSLY_HTML_CONTENT]: chatbotSafeHtml });
}
